// extracted by mini-css-extract-plugin
export var successScreen = "SuccessTab-module--successScreen--3prJ7";